export class SalesModel {
    sales_sequence: number
    sale_code: string
    
    constructor(  
        sales_sequence: number,
        sale_code: string
    ) { 
        this.sales_sequence = sales_sequence
        this.sale_code = sale_code 
    }

}